var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabLmmn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 8.73335L3.00001 7.73335C4.02668 7.12001 5.30668 7.12001 6.33334 7.73335C7.36001 8.34668 8.64001 8.34668 9.66668 7.73335C10.6933 7.12001 11.9733 7.12001 13 7.73335L14.6667 8.73335",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 2.60001L3.00001 3.60001C4.02668 4.21334 5.30668 4.21334 6.33334 3.60001C7.36001 2.98667 8.64001 2.98667 9.66668 3.60001C10.6933 4.21334 11.9733 4.21334 13 3.60001L14.6667 2.60001",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 13.4L3.00001 12.4C4.02668 11.7867 5.30668 11.7867 6.33334 12.4C7.36001 13.0133 8.64001 13.0133 9.66668 12.4C10.6933 11.7867 11.9733 11.7867 13 12.4L14.6667 13.4",
    stroke: "white",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabLmmn);
export default __webpack_public_path__ + "static/media/tabLMMN.638c61afd96b3653e2f549db4ec64108.svg";
export { ForwardRef as ReactComponent };